import React from 'react';
import { NavLink } from 'react-router-dom';


export default function Header() {

  return (
    <React.Fragment>
      {/*<CssBaseline />*/}
        <nav className="navbar is-primary p-none arch" role="navigation" aria-label="main navigation">
            <div className="container is-widescreen p-none">
                <div className="navbar-brand">
                    <div role="button" className="navbar-burger burger" aria-label="menu" aria-expanded="false"
                       data-target="navBarSecondary" style={{marginRight: 'auto', marginLeft: '0'}}>
                        <span aria-hidden="true"/>
                        <span aria-hidden="true"/>
                        <span aria-hidden="true"/>
                    </div>
                </div>
                <div id="navBarSecondary" className="navbar-menu">
                    <div className="navbar-start">
                        <NavLink exact={true} activeClassName='is-active' to='/' className="navbar-item has-text-weight-bold">Home</NavLink>
                        <NavLink activeClassName='is-active' to='/query/raw' className="navbar-item has-text-weight-bold">Query Raw Data</NavLink>
                        <NavLink activeClassName='is-active' to='/query/reduced' className="navbar-item has-text-weight-bold">Query Reduced Data</NavLink>
                        <NavLink activeClassName='is-active' to='/metdata' rel="noopener noreferrer" className="navbar-item has-text-weight-bold">Meteorological Data</NavLink>
                    </div>
                </div>
            </div>
        </nav>
      </React.Fragment>
  );
}
